import bee from "./Bee";
import utils from "./Utils";
export default {
    name: "Search",
    /*
        var query = {
            //nyd
        }
    */
    /* eslint-disable no-unused-vars */
    get_home_search_autocomplete_items(query, success, fail) {
        bee.get({
            businesses: {
                _a: "id name",
            },
            cities: {
                _a: "id name",
            },
            districts: {
                _a: "id name",
                wards: {
                    _a: "id district_id name",
                    streets: {
                        _a: "id district_id ward_id name",
                    }
                }
            }
        }).then(res => {
            var business_names = [];
            for (var i = 0; i < res.businesses.length; i++) {
                var business = res.businesses[i];
                business.kind = "business";
                business_names.push({
                    value: business,
                    text: business.name
                });
            }
            var locations_names = [];
            for (var i = 0; i < res.cities.length; i++) {
                var city = res.cities[i];
                city.kind = "city";
                locations_names.push({
                    value: city,
                    text: city.name
                });
            }
            for (var i = 0; i < res.districts.length; i++) {
                var district = res.districts[i];
                locations_names.push({
                    value: {
                        id: district.id,
                        name: district.name,
                        kind: "district"
                    },
                    text: district.name
                });
                //wards
                for (var j = 0; j < district.wards.length; j++) {
                    var ward = district.wards[j];
                    locations_names.push({
                        value: {
                            id: ward.id,
                            name: ward.name,
                            district_id: ward.district_id,
                            kind: "ward"
                        },
                        text: ward.name + ", " + district.name
                    });
                    //streets
                    for (var h = 0; h < ward.streets.length; h++) {
                        var street = ward.streets[h];
                        locations_names.push({
                            value: {
                                id: street.id,
                                name: street.name,
                                district_id: street.district_id,
                                ward_id: street.ward_id,
                                kind: "street"
                            },
                            text: street.name + ", " + ward.name + ", " + district.name
                        });
                    }
                }
            }
            success({
                business_names,
                locations_names
            });
        }).catch(errors => {
            fail(errors);
        });
    },
    /*
        var query = {
            search_term:""
        }
    */
    /* eslint-disable no-unused-vars */
    auto_complete_search_businesses(query, success, fail){
        this.search_businesses({
            search_term: query.search_term,
            is_auto_complete: true,
            location_filter: null
        }, success, fail);
    },
    /*
        var query = {
            search_term:"",
            is_auto_complete: false,
            location_filter: null
        }
    */
    /* eslint-disable no-unused-vars */
    search_businesses(query, success, fail){
        var post_data = {
            _box: query,
            _f_br: "search"
        }
        bee.get(post_data).then(res => {
            success(res.results);
        }).catch(errors => {
            fail(errors);
        });
    }
}